import React from 'react';
import Translate, {t} from "../../../components/Translate";

const AddKeyForm = ({
                        isVisible,
                        toggleFormVisibility,
                        user,
                        config,
                        currentUser,
                        editingKey,
                        newKey,
                        handleInputChange,
                        handleDescriptionChange,
                        inputError,
                        description,
                        locales,
                        editedTranslations,
                        isHtml,
                        setIsHtml,
                        handleAddKey,
                        handleEditKey,
                    }) => {

    if (!isVisible) return null;

    return (
        <div className="modal-overlay"  onClick={toggleFormVisibility}>
            <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                <h3>{editingKey ? t(currentUser.language, "editResource") : t(currentUser.language, "addNewResource")}</h3>
                <div className={`add-key-form ${isVisible ? 'visible' : 'hidden'}`}>
                    <input
                        type="text"
                        className="add-input"
                        name="keyname"
                        placeholder={t(currentUser.language, "keyName")}
                        value={newKey.keyname}
                        onChange={handleInputChange}
                        disabled={!(user.data.role === config.roles.manager)}
                        pattern="^[a-zA-Z0-9_]*$"
                        title="Only letters, numbers, and underscores are allowed"
                    />
                    {inputError && <div className="new-key-error-message">{inputError}</div>}
                    <input
                        type="text"
                        className="add-input"
                        name="description"
                        placeholder={t(currentUser.language, "description")}
                        value={description}
                        onChange={handleDescriptionChange}
                    />
                    {locales.map((locale) => (
                        <div className="locales-input-div" key={locale.locale}>
                            <span className="locale-circle">{locale.locale}</span>:
                            <textarea
                                style={{height: '60px'}}
                                className="add-input"
                                name={locale.locale}
                                placeholder={`${t(currentUser.language, "translationFor")} ${locale.locale}`}
                                value={editingKey ? editedTranslations[locale.locale] || '' : newKey.translations[locale.locale] || ''}
                                onChange={handleInputChange}
                            />
                        </div>
                    ))}
                    <div>
                        <input
                            type="checkbox"
                            checked={isHtml}
                            onChange={() => setIsHtml(!isHtml)}
                        />
                        <label><Translate language={currentUser.language} text="isHtml"/></label>
                    </div>
                    <div>
                        <button onClick={toggleFormVisibility} className={'modal-button cancel'}>
                            <Translate language={currentUser.language} text="closeForm"/>
                        </button>
                        <button
                            className={'modal-button confirm'}
                            disabled={inputError === t(currentUser.language, "newKeyErrorMessage")}
                            onClick={editingKey ? handleEditKey : handleAddKey}
                        >
                            {editingKey ? t(currentUser.language, "save") : t(currentUser.language, "add")}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default AddKeyForm;
